import _assign from "object-assign";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import warning from 'warning';
import deepmerge from 'deepmerge';
import createTheme from './createTheme';
import { createPalette, palettes } from './palette';
import { createShadows } from './shadows';
import { createTypography } from './typography';
import createThemeCharacteristics from './createThemeCharacteristics';
var overridesByComponentName = {
  MuiIconButton: {
    root: {
      // This negates the padding change made in the below commit.
      // We have quite a lot of `IconButton` usages (both direct and indirect) so it seems easier to tackle it globally.
      // https://github.com/mui-org/material-ui/pull/12865/files#diff-fde406414bd717fcea45f653b5632078
      padding: 0
    }
  }
};
/**
 * Create a theme using the default UI Toolkit themes.
 * Currently supported themes are (light/dark)
 *
 * @param {string} type - type of theme palette (light/dark)
 * @param {object} options - explicit theme options
 */

var createToolkitTheme = function createToolkitTheme(type) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (process.env.NODE_ENV !== 'production') {
    warning(Object.prototype.hasOwnProperty.call(palettes, type), "JPM-UI-Toolkit: the palette type `".concat(type, "` is not supported."));
  }

  var _options$palette = options.palette,
      paletteOption = _options$palette === void 0 ? {} : _options$palette,
      _options$shadows = options.shadows,
      shadowOption = _options$shadows === void 0 ? createShadows(type) : _options$shadows,
      _options$typography = options.typography,
      typographyOption = _options$typography === void 0 ? createTypography(type) : _options$typography,
      _options$overrides = options.overrides,
      overrides = _options$overrides === void 0 ? {} : _options$overrides,
      otherOptions = _objectWithoutProperties(options, ["palette", "shadows", "typography", "overrides"]);

  var palette = createPalette(type, undefined, paletteOption);
  var themeOverrides = deepmerge(overridesByComponentName, overrides, {
    clone: false
  });
  var characteristics = createThemeCharacteristics({
    palette: {
      type: type
    },
    shadows: {
      dark: createShadows('dark'),
      light: createShadows('light')
    }
  });
  return createTheme(_assign({
    palette: palette,
    shadows: shadowOption,
    toolkit: characteristics,
    typography: typographyOption,
    overrides: themeOverrides
  }, otherOptions));
};

export default createToolkitTheme;